<template>
    <div class="modal-mask" >
		
	<header class="mdc-top-app-bar">
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
                    aria-label="Open navigation menu" @click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0">close</button>
            </section>
            <section class="mdc-top-app-bar__section title d-flex justify-content-center">
                <div class="mdc-top-app-bar__title pdl-1"></div>
            </section>
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
                
            </section>
        </div>
    </header>

	<header class="mdc-top-app-bar top-app-bar top-header">
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
                    aria-label="Open navigation menu" @click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0">close</button>
                <span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer"></span>
            </section>
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
                
            </section>
        </div>
    </header>
		
		<!-- content -->
		
			<!-- {{ filedata }} -->
		<div class="sm_content" style="width:100%;padding-top: 54px;" v-if="file && file.resourceUri"  > 
			<img   :src="file.resourceUri" :alt="file.originalName"/>
			
		
		</div> 
		<!-- //content -->
		
	</div>
</template>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../../mixins/topAppBar.js'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
	components: {
	videoPlayer,
	TopAppBar,
  },
  props: ['filedata'],
    data() {
        return {
			file:null
        }
    },

    mixins: [topAppBarMixin],

    mounted() {
		this.setTopAppBarCloseSocialPopup('')		
        this.file = JSON.parse(localStorage.getItem('chatImage'));
	},
	methods : {
		getType(contentType) {
			return contentType.split('/')[0]
		},
		getPayerOption(img) {
			//alert($(window).width())
			return {
				//muted: true,
				language: 'en',
				controls: true,
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [{
				type: img.contentType,
				src: img.resourceUri
				}],
				height: ($(window).height()-100),
				width: ($(window).width()-10)
			}
        },
        
	}
}
</script>
